import { styled } from '@styles'

interface Props {
  width
}

export const Container = styled.div<Props>`
  width: ${({ width }) => width};
`
